import { getStepType } from './step-types.ts';
import type { Section, Step, Workflow } from './types.ts';

const FRONTMATTER_FIRST = ['name', 'description', 'kind', 'schema'];
const STEP_FIRST = ['id', 'type', 'title'];
const STEP_LAST = ['steps', 'next'];

function pick(source: Record<string, unknown>, keys: string[]): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  for (const key of keys) if (source[key] !== undefined) out[key] = source[key];
  return out;
}

export function orderFrontmatter(fm: Record<string, unknown>): Record<string, unknown> {
  const rest = Object.keys(fm)
    .filter((k) => !FRONTMATTER_FIRST.includes(k))
    .sort();
  return pick(fm, [...FRONTMATTER_FIRST, ...rest]);
}

function orderStep(step: Step): Step {
  const fieldNames = (getStepType(step.type)?.fields ?? []).map((f) => f.name);
  const known = new Set([...STEP_FIRST, ...fieldNames, ...STEP_LAST]);
  const rest = Object.keys(step)
    .filter((k) => !known.has(k))
    .sort();
  const ordered = pick(step, [...STEP_FIRST, ...fieldNames, ...rest, ...STEP_LAST]) as Step;
  if (step.steps) ordered.steps = step.steps.map(orderStep);
  if (step.next !== undefined) {
    delete ordered.next;
    ordered.next = step.next;
  }
  return ordered;
}

function orderSection(section: Section): Section {
  return { id: section.id, title: section.title, steps: section.steps.map(orderStep) };
}

export function orderWorkflow(workflow: Workflow): Partial<Workflow> & { sections: Section[] } {
  const out: Partial<Workflow> & { sections: Section[] } = { sections: workflow.sections.map(orderSection) };
  if (Object.keys(workflow.variables).length === 0) return out;
  return { variables: workflow.variables, sections: out.sections };
}
